export default __webpack_public_path__ + "static/media/lineas-de-texto.f756e38f.svg";